var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-thumbnail d-inline-block align-top logo",attrs:{"src":require("../../assets/sl-header-logo.png"),"alt":"logo"}})])])
}]

export { render, staticRenderFns }